export default "__VITE_ASSET__KVWjKFQx__"